module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step4.f3ee881b.png";